import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_LATEST_REFUND_POLICY,
  GET_REFUND_POLICY,
  POST_REFUND_POLICY,
} from "./actionTypes"

import {
  getRefundPolicySuccess,
  getRefundPolicyError,
  postRefundPolicySuccess,
  postRefundPolicyError,
  getLatestRefundPolicySuccess,
  getLatestRefundPolicyError,
} from "./actions"

import {
  genericGetRequest, postWithFileUploader
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails, bsh_getClientUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetRefundPolicy(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_refund_policies`,
      action.payload?.queryParams,
      {
        Authorization: user.token,
      }
    )
    yield put(getRefundPolicySuccess(response))
  } catch (error) {
    yield put(getRefundPolicyError(error))
  }
}

function* onPostRefundPolicy(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_refund_policies`;
    const payload = {
      body: {
        ...action.payload,
      },
      headers: {
        Authorization: user.token,
      }
    }
    const response = yield call(postWithFileUploader, URL, payload)
    yield put(postRefundPolicySuccess(response))
  } catch (error) {
    yield put(postRefundPolicyError(error))
  }
}

function* onGetLatestRefundPolicy() {
  try {
    let user = bsh_getClientUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/latest_refund_policy`;
    const response = yield call(
      genericGetRequest,
      URL,
      {},
      {
        'Authorization': user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getLatestRefundPolicySuccess(response))
  } catch (error) {
    yield put(getLatestRefundPolicyError(error))
  }
}



function* RefundPolicySaga() {
  yield takeEvery(GET_REFUND_POLICY, onGetRefundPolicy)
  yield takeEvery(POST_REFUND_POLICY, onPostRefundPolicy)
  yield takeEvery(GET_LATEST_REFUND_POLICY, onGetLatestRefundPolicy)
}

export default RefundPolicySaga

